import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { DropdownMultiselectStateType } from '../../../../../../components/dropdownMultiselect/types/dropdownMultiselectStateType';
import { DropdownMultiselectVariantType } from '../../../../../../components/dropdownMultiselect/types/dropdownMultiselectVariantType';
import { IconButtonSizeType, IconButtonVariantType, } from '../../../../../../components/iconButton/types/iconButton';
import { SelectorRowType } from '../../../../../../components/selectorRowV2/types/selectorRow';
import { ButtonSizeType, ButtonVariantType, } from '../../../../../../designSystem/reloaded/commons/components/button/variants';
import { SelectorRowVariants } from '../../../../../../designSystem/reloaded/commons/components/selectorRowV2/variants';
import { ThirdPartyAnimationSizesType as LoaderSizesType, ThirdPartyAnimationVariantType as LoaderVariantType, } from '../../../../../../designSystem/reloaded/commons/components/thirdPartyAnimation/variants';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { ActionBottomSheetVariantType } from '../../actionBottomSheet/variants';
import { PopoverVariantType } from '../../popover/variants';
import { TextVariantType } from '../../text/variants';
import { TooltipVariantType } from '../../tooltip/variants';
const commonStateStyles = (FOUNDATIONS, SHADOWS, styles) => {
    return {
        rootContainer: {
            width: '100%',
            display: 'flex',
            flex_direction: 'column',
            gap: FOUNDATIONS.spacing_150,
            ...styles?.rootContainer,
        },
        titleTooltipContainer: {
            display: 'flex',
            align_items: 'flex-start',
            gap: FOUNDATIONS.spacing_100,
            ...styles?.titleTooltipContainer,
        },
        title: {
            font_variant: TextVariantType.FONT_PARAGRAPH_200,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_neutral_font_50,
            ...styles?.title,
        },
        tooltipIconButton: {
            variant: IconButtonVariantType.SECONDARY,
            size: IconButtonSizeType.SMALL,
            ...styles?.tooltipIconButton,
        },
        tooltip: {
            variant: TooltipVariantType.REGULAR,
            ...styles?.tooltip,
        },
        inputContainerPopoverContainer: {
            position: 'relative',
            ...styles?.inputContainerPopoverContainer,
        },
        inputContainer: {
            width: '100%',
            display: 'flex',
            padding: FOUNDATIONS.spacing_200,
            align_items: 'center',
            gap: FOUNDATIONS.spacing_150,
            border_radius: FOUNDATIONS.radius_comp_forms_input_radiussize,
            outline_style: 'solid',
            outline_width: FOUNDATIONS.border_50,
            outline_color: FOUNDATIONS.color_neutral_border_150,
            background_color: FOUNDATIONS.color_comp_forms_input_bg,
            ...styles?.inputContainer,
            [DeviceBreakpointsType.TABLET]: {
                cursor: 'pointer',
                ...styles?.inputContainer?.TABLET,
            },
            [DeviceBreakpointsType.MOBILE]: {
                cursor: 'pointer',
                ...styles?.inputContainer?.MOBILE,
            },
        },
        input: {
            flex_grow: '1',
            // truncate
            text_overflow: 'ellipsis',
            white_space: 'nowrap',
            overflow: 'hidden',
            // font
            font_family: FOUNDATIONS.font_family_paragraph,
            font_size: FOUNDATIONS.font_size_paragraph_medium,
            line_height: FOUNDATIONS.font_line_height_paragraph_medium,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_comp_forms_input_filled_font,
            ...styles?.input,
        },
        inputPlaceholder: {
            font_family: FOUNDATIONS.font_family_paragraph,
            font_size: FOUNDATIONS.font_size_paragraph_medium,
            line_height: FOUNDATIONS.font_line_height_paragraph_medium,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_comp_forms_input_empty_font,
            ...styles?.inputPlaceholder,
        },
        inputIcon: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_comp_forms_input_icon,
            ...styles?.inputIcon,
        },
        popover: {
            variant: PopoverVariantType.DROPDOWN_MULTISELECT,
            ...styles?.popover,
        },
        actionBottomSheet: {
            variant: ActionBottomSheetVariantType.DROPDOWN_MULTISELECT,
            ...styles?.actionBottomSheet,
        },
        optionsContainer: {
            display: 'flex',
            flex_direction: 'column',
            align_items: 'flex-start',
            border_radius: FOUNDATIONS.radius_comp_containers_contextmenu_radiussize,
            background_color: FOUNDATIONS.color_comp_forms_input_bg,
            box_shadow: SHADOWS.shadow_40,
            // Avoid overlap with the outline ind desktop
            margin_top: FOUNDATIONS.border_100,
            ...styles?.optionsContainer,
            [DeviceBreakpointsType.TABLET]: {
                margin_top: FOUNDATIONS.border_00,
                ...styles?.optionsContainer?.TABLET,
            },
            [DeviceBreakpointsType.MOBILE]: {
                margin_top: FOUNDATIONS.border_00,
                ...styles?.optionsContainer?.MOBILE,
            },
        },
        listOptionsContainer: {
            width: '100%',
            display: 'flex',
            flex_direction: 'column',
            align_items: 'flex-start',
            padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_100}`,
            max_height: FOUNDATIONS.size_1180,
            overflow: 'auto',
            ...styles?.listOptionsContainer,
            [DeviceBreakpointsType.TABLET]: {
                padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250}`,
                max_height: 'none',
                overflow: 'unset',
                ...styles?.listOptionsContainer?.TABLET,
            },
            [DeviceBreakpointsType.MOBILE]: {
                padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250}`,
                max_height: 'none',
                overflow: 'unset',
                ...styles?.listOptionsContainer?.MOBILE,
            },
        },
        option: {
            variant: SelectorRowVariants.CUSTOM_WITH_CHECKBOX,
            type: SelectorRowType.SELECTOR_MULTIPLE,
            ...styles?.option,
        },
        optionsFooterContainer: {
            width: '100%',
            display: 'flex',
            flex_direction: 'row-reverse',
            justify_content: 'space-between',
            padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_200}`,
            gap: FOUNDATIONS.spacing_250,
            ...styles?.optionsFooterContainer,
            [DeviceBreakpointsType.TABLET]: {
                padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_300}`,
                flex_direction: 'column',
                ...styles?.optionsFooterContainer?.TABLET,
            },
            [DeviceBreakpointsType.MOBILE]: {
                padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250}`,
                flex_direction: 'column',
                ...styles?.optionsFooterContainer?.MOBILE,
            },
        },
        applyOptionsButton: {
            variant: ButtonVariantType.PRIMARY,
            size: ButtonSizeType.SMALL,
            ...styles?.applyOptionsButton,
            [DeviceBreakpointsType.TABLET]: {
                size: ButtonSizeType.LARGE,
                ...styles?.applyOptionsButton?.TABLET,
            },
            [DeviceBreakpointsType.MOBILE]: {
                size: ButtonSizeType.LARGE,
                ...styles?.applyOptionsButton?.MOBILE,
            },
        },
        removeOptionsButton: {
            variant: ButtonVariantType.SECONDARY_GHOST,
            size: ButtonSizeType.SMALL,
            ...styles?.removeOptionsButton,
            [DeviceBreakpointsType.TABLET]: {
                size: ButtonSizeType.LARGE,
                ...styles?.removeOptionsButton?.TABLET,
            },
            [DeviceBreakpointsType.MOBILE]: {
                size: ButtonSizeType.LARGE,
                ...styles?.removeOptionsButton?.MOBILE,
            },
        },
        noResultsContainer: {
            width: '100%',
            display: 'flex',
            justify_content: 'center',
            ...styles?.noResultsContainer,
        },
        emptyStateContainer: {
            width: '100%',
            display: 'flex',
            flex_direction: 'column',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_300,
            max_width: FOUNDATIONS.size_1238,
            padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
            ...styles?.emptyStateContainer,
            [DeviceBreakpointsType.TABLET]: {
                max_width: FOUNDATIONS.size_1225,
                ...styles?.emptyStateContainer?.TABLET,
            },
            [DeviceBreakpointsType.MOBILE]: {
                max_width: FOUNDATIONS.size_1200,
                ...styles?.emptyStateContainer?.MOBILE,
            },
        },
        emptyStateIllustration: {
            width: FOUNDATIONS.size_850,
            height: FOUNDATIONS.size_850,
            ...styles?.emptyStateIllustration,
        },
        emptyStateTitleDescriptionContainer: {
            width: '100%',
            display: 'flex',
            flex_direction: 'column',
            align_items: 'center',
            ...styles?.emptyStateTitleDescriptionContainer,
        },
        emptyStateTitle: {
            font_variant: TextVariantType.FONT_PARAGRAPH_100,
            font_weight: FONT_WEIGHT.font_bold,
            color: FOUNDATIONS.color_neutral_font_50,
            text_align: 'center',
            ...styles?.emptyStateTitle,
        },
        emptyStateDescription: {
            font_variant: TextVariantType.FONT_PARAGRAPH_200,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_neutral_font_50,
            text_align: 'center',
            ...styles?.emptyStateDescription,
        },
        emptyStateButton: {
            variant: ButtonVariantType.PRIMARY_GHOST,
            size: ButtonSizeType.EXTRA_SMALL,
            ...styles?.emptyStateButton,
        },
        noResultsTextContainer: {
            width: '100%',
            padding: FOUNDATIONS.spacing_150,
            ...styles?.noResultsTextContainer,
        },
        noResultsText: {
            font_variant: TextVariantType.FONT_PARAGRAPH_200,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_comp_forms_input_filled_font,
            ...styles?.noResultsText,
        },
        loadingContainer: {
            width: '100%',
            height: '260px',
            display: 'flex',
            flex_direction: 'column',
            justify_content: 'center',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_150,
            ...styles?.loadingContainer,
            [DeviceBreakpointsType.TABLET]: {
                height: '232px',
                padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
                ...styles?.loadingContainer?.TABLET,
            },
            [DeviceBreakpointsType.MOBILE]: {
                height: '232px',
                padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
                ...styles?.loadingContainer?.MOBILE,
            },
        },
        loader: {
            size: LoaderSizesType.SMALL,
            variant: LoaderVariantType.SECONDARY,
            ...styles?.loader,
        },
        loadingText: {
            text_align: 'center',
            font_variant: TextVariantType.FONT_PARAGRAPH_100,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_neutral_font_100,
            ...styles?.loadingText,
        },
        secondaryLoadingContainer: {
            width: '100%',
            display: 'flex',
            justify_content: 'center',
            align_items: 'center',
            padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_00}`,
            ...styles?.secondaryLoadingContainer,
        },
        secondaryLoader: {
            size: LoaderSizesType.SMALL,
            variant: LoaderVariantType.SECONDARY,
            ...styles?.secondaryLoader,
        },
        errorContainer: {
            display: 'flex',
            align_items: 'flex-start',
            gap: FOUNDATIONS.spacing_100,
            ...styles?.errorContainer,
        },
        errorIcon: {
            width: FOUNDATIONS.size_250,
            height: FOUNDATIONS.size_250,
            ...styles?.errorIcon,
        },
        errorText: {
            font_variant: TextVariantType.FONT_PARAGRAPH_350,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_feedback_error_font_50,
            ...styles?.errorText,
        },
        helpText: {
            font_variant: TextVariantType.FONT_PARAGRAPH_350,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
            ...styles?.helpText,
        },
    };
};
export const getRegularStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [DropdownMultiselectVariantType.REGULAR]: {
            [DropdownMultiselectStateType.EMPTY]: commonStateStyles(FOUNDATIONS, SHADOWS, {}),
            [DropdownMultiselectStateType.FILLED]: commonStateStyles(FOUNDATIONS, SHADOWS, {}),
            [DropdownMultiselectStateType.FOCUSED]: commonStateStyles(FOUNDATIONS, SHADOWS, {
                inputContainer: {
                    outline_width: FOUNDATIONS.border_100,
                    outline_color: FOUNDATIONS.color_comp_forms_input_active_border,
                },
            }),
            [DropdownMultiselectStateType.ERROR_EMPTY]: commonStateStyles(FOUNDATIONS, SHADOWS, {
                inputContainer: {
                    outline_width: FOUNDATIONS.border_100,
                    outline_color: FOUNDATIONS.color_feedback_error_border_50,
                    background_color: FOUNDATIONS.color_comp_forms_input_error_empty_bg,
                },
            }),
            [DropdownMultiselectStateType.ERROR_FILLED]: commonStateStyles(FOUNDATIONS, SHADOWS, {
                inputContainer: {
                    outline_width: FOUNDATIONS.border_100,
                    outline_color: FOUNDATIONS.color_feedback_error_border_50,
                    background_color: FOUNDATIONS.color_comp_forms_input_error_filled_bg,
                },
            }),
            [DropdownMultiselectStateType.DISABLED_EMPTY]: commonStateStyles(FOUNDATIONS, SHADOWS, {
                title: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                inputContainer: {
                    outline_color: FOUNDATIONS.color_accent_disabled_border_100,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    [DeviceBreakpointsType.TABLET]: {
                        cursor: 'default',
                    },
                    [DeviceBreakpointsType.MOBILE]: {
                        cursor: 'default',
                    },
                },
                input: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                inputPlaceholder: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                inputIcon: {
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                helpText: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            }),
            [DropdownMultiselectStateType.DISABLED_FILLED]: commonStateStyles(FOUNDATIONS, SHADOWS, {
                title: {
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
                inputContainer: {
                    outline_color: FOUNDATIONS.color_accent_disabled_border_100,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    [DeviceBreakpointsType.TABLET]: {
                        cursor: 'default',
                    },
                    [DeviceBreakpointsType.MOBILE]: {
                        cursor: 'default',
                    },
                },
                input: {
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
                inputIcon: {
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                helpText: {
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
            }),
        },
    };
};
//# sourceMappingURL=regular.js.map